export const capitalize = (s: string) => {
  if (typeof s !== 'string' || s.length < 2) return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};
